import { APP_ROUTES } from 'src/app/types/app-routes';
import { DashboardToolbarFab, DashboardToolbarItem } from './dashboard-toolbar.types';

/** Seller bottom navigation: four destinations + central "active events" FAB. */
export const SELLER_TOOLBAR_ITEMS: DashboardToolbarItem[] = [
  {
    id: 'multievento',
    labelKey: 'toolbar.multiEvent',
    url: APP_ROUTES.DASHBOARD_SELLER,
    icon: 'grid-outline',
    iconClass: 'tab-icon-multievento',
  },
  {
    id: 'eventos',
    labelKey: 'toolbar.events',
    url: APP_ROUTES.EVENTS_SELLER,
    icon: 'calendar-outline',
  },
  {
    id: 'tickets',
    labelKey: 'toolbar.tickets',
    url: APP_ROUTES.MULTI_EVENT_TICKETS,
    iconSrc: 'assets/icons/ticket-check.svg',
    iconActiveSrc: 'assets/icons/ticket-check-purple.svg',
  },
  {
    id: 'cumpleanos',
    labelKey: 'toolbar.birthdays',
    url: APP_ROUTES.BIRTHDAYS,
    icon: 'gift-outline',
  },
];

export const SELLER_TOOLBAR_FAB: DashboardToolbarFab = {
  icon: 'ticket-outline',
  iconSrc: 'assets/icons/ticket-sell.svg',
  labelKey: 'toolbar.sell',
  // Vender lleva al acceso rápido de los eventos activos; ahí el FAB queda resaltado (con la cruz).
  activeUrl: APP_ROUTES.EVENTS_SELLER_ACTIVE,
};
